import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TR } from 'src/TextRes';
import { Image, UploadImage } from '../../api';
import FAIcon from '../fAIcon/FAIcon';
import './ImageChooser.css';

export interface IImageChooserSingleProps {
    image?: Image;
    imageData?: string;
    imageDelete: boolean;
    placeHolderText?: string;
    onDelete: (image?: UploadImage) => void;
    onFileChosen: (image: UploadImage) => void;
}

export interface IImageChooserSingleState {
    openDialog: boolean;
}

export default class ImageChooserSingle extends React.PureComponent<
    IImageChooserSingleProps,
    IImageChooserSingleState
> {
    private myRef = React.createRef<HTMLInputElement>();

    constructor(props: IImageChooserSingleProps) {
        super(props);
        this.state = {
            openDialog: false,
        };
    }

    public render() {
        const { image, onDelete, placeHolderText, imageData, imageDelete } = this.props;

        let style = {};
        let url;
        if (imageData && !imageDelete) {
            url = imageData;
        } else if (image && image.ThumbnailURL && !imageDelete) {
            url = image.ThumbnailURL;
        }

        if (url) {
            style = {
                backgroundImage: 'url(' + url + ')',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            };
        }

        return (
            <div className="imageChooserSingle">
                <div className="imageHolder" style={style}>
                    <a onClick={this.openFileSelector}>
                        <FAIcon icon="upload" />
                    </a>

                    {((image && image.ThumbnailURL) || imageData) && (
                        <a
                            onClick={() => {
                                onDelete({
                                    Delete: true,
                                    FileName: '',
                                    ImageData: '',
                                });
                            }}
                        >
                            <FAIcon icon="trash" />
                        </a>
                    )}
                    {!url && placeHolderText && <em>{placeHolderText}</em>}
                    <input
                        type="file"
                        className="filechooser"
                        accept="image/*"
                        ref={this.myRef}
                        onChange={this.onChooseFile}
                    />
                </div>
                <Modal isOpen={this.state.openDialog}>
                    <ModalHeader>{TR.imageChooserMultiple_image_too_small}</ModalHeader>
                    <ModalBody>{TR.imageChooserMultiple_image_too_small_explanation}</ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.setState({ openDialog: false })}>
                            Ok
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    private openFileSelector = () => {
        if (this.myRef.current) {
            this.myRef.current.click();
        }
    };

    private onChooseFile = (e: any) => {
        if (e.target.files && e.target.files[0] && e.target.files && e.target.files[0].type.match(/image.*/)) {
            const file = e.target.files[0];
            let fileName = e.target.files[0].name;
            const pos = fileName.lastIndexOf('.');
            fileName = fileName.substr(0, pos < 0 ? fileName.length : pos) + '.jpg';

            const reader = new FileReader();

            const img = document.createElement('img');
            const canvas = document.createElement('canvas');
            reader.onload = (ev: any) => {
                img.onload = (eve: any) => {
                    const ctx2 = canvas.getContext('2d');
                    if (ctx2 === null) {
                        return;
                    }

                    const MAX_WIDTH = 1000;
                    const MAX_HEIGHT = 1000;
                    const MIN_WIDTH = 300;
                    const MIN_HEIGHT = 300;
                    let width = img.width;
                    let height = img.height;

                    if (width < MIN_WIDTH || height < MIN_HEIGHT) {
                        this.setState({ openDialog: true });
                        return;
                    }

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx2.fillStyle = '#FFFFFF';
                    ctx2.fillRect(0, 0, width, height);
                    ctx2.drawImage(img, 0, 0, width, height);

                    const imageData = canvas.toDataURL('image/jpeg', 0.8);

                    this.props.onFileChosen({
                        Delete: false,
                        FileName: fileName,
                        ImageData: imageData,
                    });
                };
                img.src = ev.target.result;
            };
            reader.readAsDataURL(file);
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/imageChooser/ImageChooserSingle.tsx